import { createRouteRef } from '@backstage/core-plugin-api';

export const eventRouteRef = createRouteRef({
  id: 'eventstatus',
  params: ['id'],
});

export const correlationRouteRef = createRouteRef({
  id: 'correlationstatus',
  params: ['correlationId'],
});
